export default "__VITE_ASSET__B7mkqpK7__"